// extracted by mini-css-extract-plugin
export default {"searchBox":"searchBox_searchBox__C7fid"};